import React from 'react';
import {FormProps} from 'core/form/formUtils';
import GridConfigCondition from 'core/grid/domain/gridConfigCondition';
import {Validate} from 'core/form/validate';
import {observer} from "mobx-react";
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import StyledDatePicker from 'core/components/fields/styledDatePicker';
import {MdTextField} from 'core/components/fields/fields';
import {FieldObjectType} from "core/form/form";
import {DATATYPE, default as MdField, VALUESOURCETYPE} from "core/metamodel/mdField";
import GridConfig from "core/grid/domain/gridConfig";
import {FILTEROPERATOR} from "core/grid/domain/grid";
import {optionsSearch} from "core/common/service/commonDataService";
import {createForm} from 'core/form/createForm';
import {toArray} from "core/common/utils/arrayUtils";
import {TIME_PATTERN_HH_mm_ss} from "core/common/utils/dateUtils";
import {loc} from "core/common/config/locales";
import {IsNumber, IsRequired, Pattern} from "core/form/rules";
import CheckBoxGroupField, {CHECKBOXGROUPSTYLE} from "core/components/fields/checkBoxGroupField";
import {grey500, grey700} from "material-ui/styles/colors";
import {LovItem} from "core/metamodel/mdEntity";

export enum CONDITIONVALUEFORMCONTEXT {
  GRIDDEF = "GRIDDEF",
  GRIDFILTER = "GRIDFILTER",
  SUPERFILTER = "SUPERFILTER",
  MULTIUPDATE = "MULTIUPDATE",
}

interface ConditionValueFormType extends FormProps<GridConfigCondition, GridConfig> {
  context: CONDITIONVALUEFORMCONTEXT
  onSuccess?: () => void;
}

@createForm({
  formName: 'ConditionValueForm',
  fields: [{
    name: 'field0',
    usePlaceholder: true,
    setFieldValueFn: (dataObject, value) => dataObject.values[0] = value,
    getFieldValueFn: (dataObject) => (dataObject.values && dataObject.values.length) ? dataObject.values[0] : undefined
  }, {
    name: 'field1',
    usePlaceholder: true,
    setFieldValueFn: (dataObject, value) => dataObject.values[1] = value,
    getFieldValueFn: (dataObject) => (dataObject.values && dataObject.values.length >= 2) ? dataObject.values[1] : undefined
  }, {
    name: 'fieldMulti',
    usePlaceholder: true,
    setFieldValueFn: (dataObject, value) => dataObject.values = (value) ? toArray(value) : value,
    getFieldValueFn: (dataObject) => dataObject.values
  }]
}, () => <noscript/>)
@observer
export default class ConditionValueForm extends React.Component<ConditionValueFormType, undefined> {


  validatorsfn = (mdField: MdField, dataObject: GridConfigCondition) => {
    let rules = (mdField.dataType === DATATYPE.TIME || mdField.dataType === DATATYPE.DURATION) ? [<Pattern key={1}
                                                                                                           pattern={TIME_PATTERN_HH_mm_ss}/>]
      : ((mdField.dataType === DATATYPE.NUMBER || mdField.dataType === DATATYPE.NUMBERCURRENCY) ? [<IsNumber
        key={1}/>] : []);

    if (!dataObject.superFilter) {
      rules.push(<IsRequired key={rules.length + 1}/>)
    }

    return rules;
  };

  onChangeSuperFilter = (values: LovItem[]) => {
    let {dataObject, formName} = this.props;
    let {field0, field1, fieldMulti} = (dataObject.getForm(formName).fields as { [key: string]: FieldObjectType });
    console.log("onChangeSuperFilter: ", values)
    fieldMulti.props.onChange(values);
    if (this.props.onSuccess) this.props.onSuccess();
  }


  render() {
    let {dataObject, disabled, formName, context} = this.props;

    // tyto jsou virtualni, definovane pomoci get/setFieldValueFn, neexistuji na GridConfigCondition, proto musim pretypovat fields
    let {field0, field1, fieldMulti} = (dataObject.getForm(formName).fields as { [key: string]: FieldObjectType });

    let operator: FILTEROPERATOR = dataObject.operator;


    console.log('conditionValue render: field0.valid = %s, field0.showValidation = %s, field0.value = %O, mdField = %o', field0.valid, field0.showValidation, field0.getFieldValueFn(dataObject), field0.mdField);

    if (['EQUAL', 'NOTEQUAL', 'STARTSWITH', 'NOTSTARTSWITH', 'ENDSWITH', 'NOTENDSWITH', 'GREATERTHAN', 'GREATEROREQUALTHAN',
      'LESSTHAN', 'LESSOREQUALTHAN', 'CONTAINS', 'NOTCONTAINS', 'LASTXDAYS', 'NEXTXDAYS'].includes(
      operator)) {
      return (
        <div>
          <FilterFieldComp {...field0.props}
                           hintText={(context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? field0.textLabel : loc.i18n`Fill Value`}
                           disabled={disabled} operator={operator} context={context}/>
          <Validate field={field0} value={field0.props.value}>
            {this.validatorsfn(field0.mdField, dataObject)}
          </Validate>
        </div>
      );
    } else if (['IN', 'NOTIN'].includes(operator)) {
      let fieldMultiProps = (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? {...fieldMulti.props, onChange: this.onChangeSuperFilter} : fieldMulti.props;
      return (
        <div>
          <FilterFieldComp {...fieldMultiProps}
                           hintText={(context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? fieldMulti.textLabel : "Choose values"}
                           multi={true} disabled={disabled} operator={operator} context={context}/>
          <Validate field={fieldMulti} value={fieldMulti.props.value} onSuccess={this.props.onSuccess}>
            {(dataObject.superFilter) ? null : <IsRequired/>}
          </Validate>
        </div>
      );
    } else if (operator === 'FROMTO') {
      return (
        <div style={{display: 'flex'}}>
          <FilterFieldComp {...field0.props}
                           hintText={(context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? field0.textLabel : loc.i18n`Fill Value: From`}
                           disabled={disabled} operator={operator} context={context}/>
          <Validate field={field0} value={field0.props.value}>
            {this.validatorsfn(field0.mdField, dataObject)}
          </Validate>
          <div style={{alignSelf: 'center'}}> -</div>
          <FilterFieldComp {...field1.props}
                           hintText={(context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? field1.textLabel : loc.i18n`Fill Value: To`}
                           disabled={disabled} operator={operator} context={context}/>
          <Validate field={field1} value={field1.props.value}>
            {this.validatorsfn(field1.mdField, dataObject)}
          </Validate>
        </div>
      );

    } else if (['ISTRUE', 'ISFALSE', 'ISNULL', 'ISNOTNULL'].includes(operator)) {
      return null;
    } else {
      return null;
    }

  }


}


export const FilterFieldComp = observer(({mdField, operator, showBooleanField, context, ...other}: { mdField?: MdField, operator?: FILTEROPERATOR, showBooleanField?: boolean, context: CONDITIONVALUEFORMCONTEXT, [key: string]: any }) => {

  let {options, style, ...localOther} = other;

  let localStyle = style;
  if (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) {
    localStyle = {...localStyle, height: 40, color: grey700};
    localOther.labelStyle = {...localOther.labelStyle, color: grey700};
    localOther.inputStyle = {...localOther.inputStyle, marginTop: 0, color: grey700};
    localOther.hintStyle = {...localOther.hintStyle, bottom: 10, color: grey700};

  }

  if (mdField.valueSource) {
    if (mdField.valueSourceType === VALUESOURCETYPE.ASYNC) {
      return <StyledSelect  {...localOther} async={true} asterixForAll={true}
                            loadOptions={optionsSearch.bind(this, mdField.valueSource, {_context: context})}
                            clearable={true} style={localStyle} options={options}/>;
    } else {
      if (options && options.length) options = options.filter(lov => lov.value !== null);
      return (context === CONDITIONVALUEFORMCONTEXT.SUPERFILTER) ? <CheckBoxGroupField options={options} style={localStyle}
                                                                                       groupStyle={CHECKBOXGROUPSTYLE.HORIZONTAL} {...localOther} /> :
        <StyledSelect options={options} style={localStyle} {...localOther} />
    }
  } else {
    if (!mdField.dataType) throw 'Field ' + mdField.fieldKey + ' has no valueSource nor a dataType';

    switch (mdField.dataType) {
      case DATATYPE.NUMBER:
      case DATATYPE.NUMBERCURRENCY:
        return (
          <NumberField {...localOther} style={localStyle}/>
        );
      case DATATYPE.STRING:
      case DATATYPE.TIME:
      case DATATYPE.DURATION:
        return (
          <MdTextField {...localOther} maxLength={255} style={localStyle}/>
        );
      case DATATYPE.DATE:
        return (
          (operator === FILTEROPERATOR.LASTXDAYS || operator === FILTEROPERATOR.NEXTXDAYS) ?
            <NumberField {...localOther} style={localStyle}/> : <StyledDatePicker {...localOther} style={localStyle}/>
        );
      case DATATYPE.DATETIME:
        return (
          (operator === FILTEROPERATOR.LASTXDAYS || operator === FILTEROPERATOR.NEXTXDAYS) ?
            <NumberField {...localOther} style={localStyle}/> : <StyledDatePicker {...localOther} time style={localStyle}/>
        );
      case DATATYPE.BOOLEAN:
        return ((showBooleanField) ? <StyledSelect {...localOther} clearable={false} style={localStyle}
                                                   options={[{value: "true", label: loc.i18n`Yes`}, {
                                                     value: "false",
                                                     label: loc.i18n`No`
                                                   }]}/> : null);
      default :
        return null;
    }
  }


});



// WEBPACK FOOTER //
// ./src/core/grid/component/conditionValueForm.tsx